var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mt-5",attrs:{"prominent":"","outlined":"","type":"info","border":"left","color":"defaultColor"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }